export enum MessageFolderEnum {
  ARCHIVE = "archive",
  INBOX = "inbox",
  OUTBOX = "outbox",
  JUNK = "junk"
}
